import { FormManager } from '@bark/bark-core/src/components/legacy-scripts/form-manager';
import { verifyPhoneNumberChange, verifyPhoneNumberIsMobile, showConfirmation } from "../components/verify-contact";
import { CameraUtil, _t } from "@bark/bark-core";
import { getRecaptchaToken } from "@bark/bark-core/src/helpers/reCAPTCHA";

export default async function() {
    const { Bark : { api, apiVersionHeader, showFormErrorsBootstrap, USER } } = window;
    let state;
    let initialState;
    const cameraUtil = CameraUtil();
    const formManager = FormManager();

    const formManagerName = 'buyer-account-details'

    const init = () => {
        getSelf();
        registerFormFields();
        cameraUtil.setConfig({
            endpoint: '/buyer/avatar/',
            endpointVersion: apiVersionHeader('v1'),
            onSuccess: (data) => {avatarSuccess(data.image_url)},
            onError: () => {showAvatarError()},
        })

        addListeners();
        hideWebCamIfMobile();
    }

    const updateEmailAddress = async (deferred) => {
        var payload = {}
        try {
            payload.email = $('#user_email_address').val();
            payload.captchaToken = await getRecaptchaToken('update_email');
            payload.platform = 'web';
        } catch (e) {
            console.error('Error getting reCAPTCHA token:', e);
            return false;
        };

        if (!validateUpdateEmail(payload.email)) {
            deferred.reject($('label[for="user_email_address"]'));
            return false;
        }


        Bark.showLoading();

        Bark.api('user/email', payload, function (e) {
            Bark.hideLoading();

            if (e.errors) {
                handleFormErrors(e.errors);
                deferred.reject($('label[for="user_email_address"]'));
                return;
            }

            if (e.status) {
                Bark.json({url: '/json/reset-seller-session/'}).fail(function () {
                    Bark.jsr.logError('reset-seller-session', 'Email updated ok. Failed to set session');
                    console.error('Email address was updated okay, but there was an error updating your session.');
                });

                $('#user_email_address').data('data-original-email', payload.email);

                deferred.resolve();
                formManager.dirty('accountDetails-account-email', false);
                return;
            }

            deferred.reject($('label[for="user_email_address"]'));

            errorModal(_t('buyer_account-settings:input.user-email-address.error.updating'));

        }, function (err) {
            Bark.hideLoading();
            deferred.reject($('label[for="user_email_address"]'));
            errorModal(_t('buyer_account-settings:input.user-email-address.error.updating'));
        }, 'POST');

        return true;
    };

    /**
     * Handle form errors returned from the API
     * @param {array} errors An array of objects, with each object in the form<pre>
     *  {
     *      fieldname: string,
     *      msg: string
     *  }
     */
    const handleFormErrors = (errors) => {
        var i;
        for (i = 0; i < errors.length; i++) {
            if (errors[i].fieldname === 'general') {
                Bark.alertModal(errors[i].msg, 'Close');
            } else {
                Bark.showFormErrorsBootstrap(errors[i].fieldname, errors[i].msg);
                $('.form-group .invalid-feedback').removeClass('d-none');
            }
        }
    }

    /**
     * Show the error modal
     * @param {string} msg [optional] The error message to show
     * @param {boolean} keepModalsOpen [optional] True to keep the current modal open
     */
    const errorModal = (msg, keepModalsOpen) => {
        if (!keepModalsOpen) {
            $('.modal').modal('hide');
        }

        Bark.alertModal(msg || _t('buyer_account-settings:error.completing-request'));
        Bark.hideLoading();
    }

    /**
     * Validate an email address locally
     * @param {string} emailAddress The email address to validate
     * @returns {boolean}
     */
    const validateUpdateEmail = (emailAddress) => {
        let error = '';

        if (!emailAddress) {
            error = _t('buyer_account-settings:input.user-email-address.error.empty');
        }

        if (!emailAddress.match(/\S+@\S+\.\S+/)) {
            error = _t('buyer_account-settings:input.user-email-address.error.invalid');
        }

        if (error) {
            const input = $(`#profile_email`);
            input.addClass('is-invalid');
            const $feedBack = input.parent().find('.invalid-feedback');
            $feedBack.text(error);
            $feedBack.removeClass('d-none');
            return false;
        }

        return true;
    }

    /**
     * Validate the updated password
     * @param {string} currentPassword The old password
     * @param {string} newPassword The proposed new password
     * @param {string} confirmPassword Confirmation of the new password
     * @param loginMethod
     * @returns {boolean} <b>True</b> if the password passed local validation
     */
    const validateUpdatePassword = (currentPassword = '', newPassword = '', confirmPassword = '', loginMethod = 'password') => {

        const isLoginMethodPassword = loginMethod === 'password';

        if (isLoginMethodPassword && !currentPassword) {
            Bark.showFormErrorsBootstrap('account_current_password', _t('buyer_account-settings:input.current-password.error.empty'));
            $('#account_current_password-error').removeClass('d-none');
            return false;
        }

        if (!newPassword) {
            Bark.showFormErrorsBootstrap('account_new_password', _t('buyer_account-settings:input.new-password.error.empty'));
            $('#account_new_password-error').removeClass('d-none');
            return false;
        }

        if (newPassword.length < 6) {
            Bark.showFormErrorsBootstrap('account_new_password', _t('buyer_account-settings:input.new-password.error.too-short'));
            $('#account_new_password-error').removeClass('d-none');
            return false;
        }

        if (isLoginMethodPassword && currentPassword === newPassword) {
            Bark.showFormErrorsBootstrap('account_new_password', _t('buyer_account-settings:input.new-password.error.same'));
            $('#account_new_password-error').removeClass('d-none');
            return false;
        }

        if (confirmPassword !== newPassword) {
            Bark.showFormErrorsBootstrap('account_new_password_confirm', _t('buyer_account-settings:input.new-password.error.no-match'));
            $('#account_new_password_confirm-error').removeClass('d-none');
            return false;
        }

        return true;
    }

    const clearPasswordForm = () => {
        if($('#account_current_password').length) {
            $('#account_current_password').val('');
        }
        $('#account_new_password').val('');
        $('#account_new_password_confirm').val('');
    }

    /* from old account-details */

    const hideWebCamIfMobile = () => {
        if( Bark.isMobile() ) {
            $('#profile_picture_cam').hide();
        }
    }

    const showAvatarError = (error) => {
        error = error ? error: _t('buyer_account-settings:input.avatar.error.upload');

        $('#profile_photo_div .invalid-feedback').text(error).removeClass('d-none').addClass('d-block');
    }

    const removeAvatarError = () => {
        $('#profile_photo_div .invalid-feedback').removeClass('d-block').addClass('d-none');
    }

    const updateAvatar = (src) => {
        if (src && typeof src === 'string') {
            $('#profile_picture').attr('src', src);
            $('#bark-header img.default-avatar').attr('srcset', src).attr('src', src).removeClass('d-none');
            $('#bark-header .default-avatar.user-letter').attr('style', 'display: none!important');
        }
        state.avatar = initialState.avatar = src;
    }

    const updateNameInHeader = () => {
        $('.js-buyer-username').text(state.name);
    }

    const updateFields = (fieldsToUpdate) => {
        for (let [key, value] of Object.entries(fieldsToUpdate)) {
            if (key === 'avatar') {
                updateAvatar(value);
            }

            $(`#profile_${key}`).val(value);
        }
    }

    const handleChange = (event) => {
        let { name, value } = event.target;

        if (name === 'profile_picture_file') {
            return;
        }

        name = name.replace('profile_', '');
        state = {...state, [name]: value};


        const isDirty = value !== initialState[name];

        formManager.dirty(formManagerName, true);
        if (!isDirty) {
            hideAllErrors();
        }
    }

    const showErrors = (errors) => {
        for (let [key, value] of Object.entries(errors)) {
            let input = $(`#profile_${key}`);
            input.addClass('is-invalid');

            let $feedBack = input.parent().find('.invalid-feedback');
            formManager.dirty(key, true);

            $feedBack.text(value[0]);
            $feedBack.removeClass('d-none');
        }
    }

    const shouldTriggerPhoneVerification = (tel) => {
        return initialState.tel !== tel && initialState.phoneVerified && !Bark.USER.isAdmin;
    }

    const processProfileWithPhoneChange = ({email, name, tel}, deferred) => {
        if (initialState.isMobile) {
            verifyPhoneNumberChange(
                tel,
                () => {
                    saveProfile({email, name, tel}, deferred);
                    formManager.endSubmit($('#form-manager-save'));
                },
                () => {
                    showPhoneError();
                    formManager.endSubmit($('#form-manager-save'));
                }
            );
        } else {
            verifyPhoneNumberIsMobile(
                tel,
                () => {
                    verifyPhoneNumberChange(
                        tel,
                        () => {
                            saveProfile({email, name, tel}, deferred);
                            formManager.endSubmit($('#form-manager-save'));
                        },
                        () => {
                            showPhoneError();
                            formManager.endSubmit($('#form-manager-save'));
                        }
                    )
                },
                () => {
                    saveProfile({email, name, tel}, deferred);
                    formManager.endSubmit($('#form-manager-save'));
                }
            );
        }
    }

    const processProfile = ({email, name, tel}, deferred) => {

        if (shouldTriggerPhoneVerification(tel)) {
            api(
                '/buyer/validate-profile',
                {email, name, tel},
                (res) => {
                    if (res.status) {
                        processProfileWithPhoneChange({email, name, tel}, deferred);
                    }
                },
                (error) => {
                    let {responseJSON: {error: apiError}} = error
                    hideAllErrors()

                    if (apiError.errors) {
                        showErrors(apiError.errors);
                    }
                    formManager.dirty(formManagerName, true);
                    deferred.reject();
                    formManager.endSubmit($('#form-manager-save'));
                },
                'POST',
                apiVersionHeader('v2')
            )
        } else {
            saveProfile({email, name, tel}, deferred);
            formManager.endSubmit($('#form-manager-save'));
        }
    }

    const showPhoneError = () => {
        const error = _t('buyer_account-settings:input.phone.error.invalid');

        $('#profile_tel_div .invalid-feedback').text(error).removeClass('d-none').addClass('d-block phone-error');
    }

    const removePhoneError = () => {
        $('#profile_tel_div .invalid-feedback').text("").removeClass('d-block phone-error').addClass('d-none');
    }

    const saveProfile = async ({email, name, tel}, deferred) => {
        const {ga} = window;
        const captchaToken = await getRecaptchaToken('buyer_profile');
        api(
            '/buyer/profile',
            {email, name, tel, captchaToken, platform: 'web'},
            (res) => {
                if (res.status) {
                    hideAllErrors()
                    initialState = state;
                    deferred.resolve();
                    formManager.dirty(formManagerName, false);
                    ga('send', 'user_change_settings');
                    updateNameInHeader();
                    removePhoneError();
                    updateVerifiedPhone();
                    showConfirmation();
                }
            },
            (error) => {
                let {responseJSON: {error: apiError}} = error
                hideAllErrors()

                if (apiError.errors) {
                    showErrors(apiError.errors);
                }
                formManager.dirty(formManagerName, true);
                deferred.reject();
            },
            'POST',
            apiVersionHeader('v2')
        )
    }

    const resetToInitialState = () => {
        hideAllErrors();
        updateFields(initialState);

        formManager.dirty(formManagerName, false);
    }

    const removeWaiting = (target) => {
        target.removeClass('waiting');
    }

    const getSelf = () => {
        api(
            '/buyer/self',
            {},
            (response) => {
                const {data} = response;

                if (data) {
                    const { email, name, telephone:tel, avatar } = data;
                    initialState = state = {email, name, tel, avatar}
                    updateFields(state)
                    removeWaiting($('.name-profile-picture-container'));
                    updateVerifiedPhone();
                }
            },
            (error) => {
                bugsnagClient.notify(error)
            },
            'GET'
        )
    }

    const updateVerifiedPhone = () => {
        api(
            '/buyer/is-phone-verified',
            {},
            (response) => {
                const {status, isMobile} = response;
                initialState.phoneVerified = state.phoneVerified = status;
                initialState.isMobile = state.isMobile = isMobile;
                if (status) {
                    if (status) {
                        $('#phoneVerifiedBadge').addClass('d-flex').removeClass('d-none');
                    }
                }
            },
            (error) => {
                bugsnagClient.notify(error)
            },
            'GET',
            apiVersionHeader('v2')
        )
    }

    const addListeners = () => {
        $('.profile_picture_link').on('click', function(e) {
            e.preventDefault();
            $('.profile_picture_file').trigger('click');
        });

        $('.profile_picture_file').on('change', function(e) {
            e.preventDefault();
            startSubmit($('.profile_picture_link'));
            var formData = new FormData();
            formData.append('image', $(this).get(0).files[0]);
            formData.append('type', 'chat-avatar');
            Bark.api(
                'buyer/avatar/',
                formData,
                function (data) {
                    endSubmit($('.profile_picture_link'));
                    avatarSuccess(data.image_url)
                },
                function () {
                    showAvatarError();
                    endSubmit($('.profile_picture_link'));
                },
                'POST',
                Bark.apiVersionHeader('v1'),
                false,
                false,
                false
            );
        });

        $('.profile_picture_cam').on('click', function(e) {
            e.preventDefault();
            cameraUtil.onOpenCameraClick();
        });

        $('.form input').on('change.update, keyup', function (event) {
            handleChange(event);
        });


        $('.js-update-password').off('click.update').on('click.update', function () {

            const loginMethod = $('#login_method_for_change_password').val();
            let payload = {
                newpass: $('#account_new_password').val(),
                currentpass: null
            };

            if(loginMethod === 'password') {
                payload.currentpass = $('#account_current_password').val();
            }

            if (!validateUpdatePassword(payload.currentpass, payload.newpass, $('#account_new_password_confirm').val(), loginMethod)) {
                return;
            }

            Bark.showLoading();

            Bark.api('user/password-web', payload, function (e) {
                if (e.status) {
                    $('#change-password-modal').modal('hide');

                    // As the password is in the network logs in plain text, reload the page.
                    document.location.reload();
                    return;
                }

                Bark.hideLoading();

                if (e.errors) {
                    handleFormErrors(e.errors);
                    return;
                }

                Bark.alertModal(e.message || _t('buyer_account-settings:error.changing-password'));
            }, function () {
                errorModal();
            }, 'POST');
        });

        $('.js-close-change-password-modal').off('click.close').on('click.close', function () {
            clearPasswordForm();
        });

        $('.close-modal-cross').click(function () {
            clearPasswordForm();
        });

        formManager.register('accountDetails-account-email', function (deferred) {
            updateEmailAddress(deferred);
        }, function() {

            $('#user_email_address').val($('#user_email_address').data('original-email'));
            formManager.dirty('accountDetails-account-email', false);
        }, () => {showConfirmation()});

        $('#user_email_address').off('change.update, keyup').on('change.update, keyup', function(){
            formManager.dirty('accountDetails-account-email', true);
        });

        $('#user_email_address').off('change.update, keyup').on('change.update, keyup', function(){
            formManager.dirty('accountDetails-account-email', true);
        });

        $('#profile_tel').off('change.telephone, keyup').on('change.telephone, keyup', function(){
            if (initialState.tel == $('#profile_tel').val()) {
                if (initialState.phoneVerified) {
                    $('#phoneVerifiedBadge').addClass('d-flex').removeClass('d-none');
                }
            } else {
                $('#phoneVerifiedBadge').removeClass('d-flex').addClass('d-none');
            }
            removePhoneError();
        });

        formManager.show();

        $('#account_details').removeClass('waiting');
    }

    const hideAllErrors = () => {
        $('.form-control').removeClass('is-invalid');
        $('.form-group .invalid-feedback').addClass('d-none');
    }

    const registerFormFields = () => {
        formManager.register(
            formManagerName,
            (deferred) => {processProfile(state, deferred)},
            () => {resetToInitialState()},
            () => {showConfirmation()}
        )
    }

    const avatarSuccess = (avatarUrl) => {
        removeAvatarError();
        updateFields({avatar: avatarUrl})
    }

    const startSubmit = ($submitElement) => {
        $submitElement.addClass('submit-waiting');
        $submitElement.addClass('disabled');
    }

    const endSubmit = ($submitElement) => {
        $submitElement.removeClass('submit-waiting');
        $submitElement.removeClass('disabled');
    }

    init();
}
